module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/group_with_child-6ba4545c7627307814e940c7e54c9f29.webp";